<template>
  <div v-if="!requisicoes.finalizado" class="loading-overlay">
    <div class="spinner"></div>
  </div>
  <div v-if="requisicoes.finalizado">
    <!-- Banner Perfil Investidor -->
    <div v-if="!Edicao" class="form-info-banner">
      <div class="flex items-center justify-between">
        <div>
          <h3 class="form-info-banner-title" v-if="dadosUsuario.PerfilRisco == ''">
            Descubra agora seu perfil investidor
          </h3>
          <h3 class="form-info-banner-title" v-if="dadosUsuario.PerfilRisco != ''">
            Resultado: {{ dadosUsuario.PerfilRisco }}
          </h3>
          <p class="form-info-banner-text" v-if="dadosUsuario.PerfilRisco == ''">
            Caso queira, você poderá salvar e continuar depois.
          </p>
        </div>
        <div>
          <div v-if="dadosUsuario.PerfilRisco != ''" class="relative inline-block">
            <span
              v-if="dadosUsuario.NecessarioRefazerSuitability"
              class="badge-novo-questionario"
            >
              Novo questionário
            </span>
            <button class="btn-primary" @click="abrirQuestionario()">
              Refazer questionário
            </button>
          </div>
          <button
            v-if="dadosUsuario.PerfilRisco == ''"
            class="btn-primary"
            @click="abrirQuestionario()"
          >
            Preencher questionário
          </button>
        </div>
      </div>
    </div>

    <!-- Seção: Dispensa do questionário -->
    <section class="form-section" v-if="!bloquearDispensaQuestionario">
      <div class="form-section-header">
        <LabelDisclaimer
          :TamanhoFonteLabel="'H5'"
          :NomeLabel="'Dispensa do questionário'"
          :TipoCliente="'Pessoa Jurídica'"
          :Sessao="'Produtos'"
          :SubSessao="'Dispensa do questionário'"
        />
      </div>
      <div class="form-section-content">
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required">Dispensar questionário?</label>
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="false"
                  name="DispensarQuestionario"
                  class="form-radio-input"
                  @change="abrirModalDispensa"
                  v-model="dispensar"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  value="true"
                  name="DispensarQuestionario"
                  class="form-radio-input"
                  @change="abrirModalDispensa"
                  v-model="dispensar"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-grid-1" v-if="dispensar == 'true' || dispensar == true">
          <div class="form-field">
            <label class="form-field-label form-field-label-required" for="motivoDispensaQuestionario">Motivo da dispensa do questionário</label>
            <select
              id="motivoDispensaQuestionario"
              @change="alterarDispensa"
              v-model="dispensaQuestionario.MotivoDispensaQuestionarioId"
              class="field"
            >
              <option value="">Selecione</option>
              <option
                v-for="item in listaMotivosDispensa"
                :key="item.Id"
                :value="item.Id"
              >
                {{ item.Descricao }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </section>

    <!-- Seção: Produtos -->
    <section
      v-if="
        this.nomeEmpresa != 'ACTUAL' ||
        (this.nomeEmpresa == 'ACTUAL' && this.Edicao == true)
      "
      class="form-section"
    >
      <div class="form-section-header">
        <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100">Produtos</h3>
        <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Preencha o questionário Suitability para ter acesso aos melhores
          produtos de acordo com o seu perfil.
        </p>
      </div>

      <div class="form-section-content" v-if="produtosFiltrados && produtosFiltrados.length > 0">
        <!-- Desktop Table -->
        <div class="hidden md:block border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden">
          <table class="w-full">
            <thead class="bg-gray-50 dark:bg-slate-800">
              <tr>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Nome do produto
                </th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  CNPJ
                </th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Perfil
                </th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                  Vigência
                </th>
                <th
                  v-if="configuracaoVisualizacaoTermosProdutos"
                  class="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider"
                >
                  Ações
                </th>
              </tr>
            </thead>
            <tbody v-if="dadosUsuario.PerfilRisco != ''" class="bg-white dark:bg-slate-900 divide-y divide-gray-200 dark:divide-slate-700">
              <tr
                v-for="(produto, index) in produtosFiltrados"
                :key="index"
                class="hover:bg-gray-50 dark:hover:bg-slate-800 transition-colors"
              >
                <td class="px-4 py-3 text-sm font-medium text-gray-900 dark:text-gray-100">
                  {{ produto.Descricao }}
                </td>
                <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                  {{ produto.Cnpj != null ? formatCpfCnpj(produto.Cnpj) : "" }}
                </td>
                <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                  {{ produto.PerfilNome }}
                </td>
                <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                  {{ produto.Vigencia > 0 ? produto.Vigencia : "Não se aplica" }}
                </td>
                <td v-if="configuracaoVisualizacaoTermosProdutos" class="px-4 py-3 text-sm">
                  <div class="flex gap-2">
                    <button
                      v-if="
                        configuracaoVisualizacaoTermosProdutos &&
                        !listaProdutosCliente.some(
                          (produtoCliente) =>
                            produtoCliente.ProdutoId === produto.ProdutoId &&
                            produtoCliente.Aceite == true,
                        ) &&
                        this.nomeEmpresa != 'ACTUAL'
                      "
                      @click="lerTermos(produto.ProdutoId)"
                      class="px-3 py-1.5 text-xs font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
                    >
                      Ler os termos
                    </button>
                    <button
                      v-if="
                        !listaProdutosCliente.some(
                          (produtoCliente) =>
                            produtoCliente.ProdutoId === produto.ProdutoId &&
                            produtoCliente.Aceite == true,
                        ) && this.nomeEmpresa == 'ACTUAL'
                      "
                      @click="lerTermos(produto.ProdutoId)"
                      class="px-3 py-1.5 text-xs font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
                    >
                      Pendente de assinatura
                    </button>
                    <button
                      v-if="
                        listaProdutosCliente.some(
                          (p) =>
                            p.ProdutoId == produto.ProdutoId &&
                            p.Aceite == true,
                        )
                      "
                      disabled
                      class="px-3 py-1.5 text-xs font-medium text-white bg-blue-400 dark:bg-blue-500 rounded-lg cursor-not-allowed opacity-75"
                    >
                      Produto Adquirido
                    </button>
                    <button
                      v-if="
                        listaProdutosCliente.some(
                          (produtoCliente) =>
                            produtoCliente.ProdutoId === produto.ProdutoId &&
                            produtoCliente.Aceite == true,
                        )
                      "
                      @click="visualizarTermos(produto.ProdutoId)"
                      class="px-3 py-1.5 text-xs font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
                    >
                      Ver mais
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile Cards -->
        <div class="md:hidden space-y-3">
          <template
            v-for="(produto, index) in produtosFiltrados"
            :key="index"
          >
            <div
              v-if="produto.Descricao && dadosUsuario.PerfilRisco != ''"
              class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 space-y-3 bg-white dark:bg-slate-800"
            >
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Descrição</p>
              <p class="text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ produto.Descricao }}
              </p>
            </div>

            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">CNPJ</p>
              <p class="text-sm text-gray-700 dark:text-gray-300">
                {{ produto.Cnpj != null ? formatCpfCnpj(produto.Cnpj) : "" }}
              </p>
            </div>

            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Perfil</p>
              <p class="text-sm text-gray-700 dark:text-gray-300">
                {{ produto.PerfilNome }}
              </p>
            </div>

            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Vigência</p>
              <p class="text-sm text-gray-700 dark:text-gray-300">
                {{ produto.Vigencia > 0 ? produto.Vigencia : "Não se aplica" }}
              </p>
            </div>

            <div v-if="configuracaoVisualizacaoTermosProdutos" class="flex flex-col gap-2 pt-2">
              <button
                v-if="
                  configuracaoVisualizacaoTermosProdutos &&
                  !listaProdutosCliente.some(
                    (produtoCliente) =>
                      produtoCliente.ProdutoId === produto.ProdutoId &&
                      produtoCliente.Aceite == true,
                  ) &&
                  this.nomeEmpresa != 'ACTUAL'
                "
                @click="lerTermos(produto.ProdutoId)"
                class="w-full px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
              >
                Ler os termos
              </button>
              <button
                v-if="
                  !listaProdutosCliente.some(
                    (produtoCliente) =>
                      produtoCliente.ProdutoId === produto.ProdutoId &&
                      produtoCliente.Aceite == true,
                  ) && this.nomeEmpresa == 'ACTUAL'
                "
                @click="lerTermos(produto.ProdutoId)"
                class="w-full px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
              >
                Pendente de assinatura
              </button>
              <button
                v-if="
                  listaProdutosCliente.some(
                    (p) =>
                      p.ProdutoId == produto.ProdutoId &&
                      p.Aceite == true,
                  )
                "
                disabled
                class="w-full px-4 py-2 text-sm font-medium text-white bg-blue-400 dark:bg-blue-500 rounded-lg cursor-not-allowed opacity-75"
              >
                Produto Adquirido
              </button>
              <button
                v-if="
                  listaProdutosCliente.some(
                    (produtoCliente) =>
                      produtoCliente.ProdutoId === produto.ProdutoId &&
                      produtoCliente.Aceite == true,
                  )
                "
                @click="visualizarTermos(produto.ProdutoId)"
                class="w-full px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
              >
                Ver mais
              </button>
            </div>
          </div>
          </template>
        </div>
      </div>
    </section>
    <ModalQuestionario />
    <ModalProdutos />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalQuestionario from "../Questionario/ModalQuestionario.vue";
import ModalProdutos from "../Produtos/ModalInformativoProdutos.vue";
import formatCpfCnpj from "@/utils/formatCpfCnpj";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";

export default {
  name: "CadastroPJ_Produtos",
  props: ["Edicao"],
  mixins: [formatCpfCnpj],
  components: { LabelDisclaimer, ModalQuestionario, ModalProdutos },
  computed: {
    ...mapGetters({
      permitirAvancar: false,
      user: "auth/user",
      listaProdutos: "GET_LISTA_PRODUTOS",
      listaProdutosCliente: "GET_LISTA_PRODUTOS_CLIENTE",
      perfilCliente: "GET_PERFIL_CLIENTE",
      listaMotivosDispensa: "GET_LISTA_MOTIVO_DISPENSA",
      infoObjDispensa: "GET_PF_PJ_SALVAR_INFO_DISPENSA",
      infoDispensaQuestionario: "GET_PF_PJ_INFO_DISPENSA_QUESTIONARIO",
      configDispensaQuestionario: "GET_DISPENSA_QUESTIONARIO",
      getConfiguracoes: "GET_CONFIGURACOES",
      perfilSuitabilityPreview: "GET_SUITABILITY_PREVIEW",
    }),
    produtosFiltrados() {
      if (this.nomeEmpresa != "ACTUAL") {
        return this.listaProdutos;
      } else if (this.nomeEmpresa == "ACTUAL" && !this.Edicao) {
        return [];
      } else if (this.nomeEmpresa == "ACTUAL" && this.Edicao) {
        return this.listaProdutos?.filter((produto) =>
          this.listaProdutosCliente.some(
            (produtoCliente) => produtoCliente.ProdutoId === produto.ProdutoId,
          ),
        );
      } else {
        return [];
      }
    },
  },
  data() {
    return {
      configuracaoVisualizacaoTermosProdutos: false,
      requisicoes: {
        listaProdutos: false,
        perfilCliente: false,
        listaProdutosCliente: false,
        configDispensaQuestionario: false,
        finalizado: false,
      },
      bloquearDispensaQuestionario: false,
      nomeEmpresa: "",
      permitirAvancar: true,
      filtroPerfilNome: "",
      dispensar: false,
      dispensaQuestionario: {
        MotivoDispensaQuestionarioId: "",
        DataQuestionario: null,
      },
      dadosUsuario: {
        PerfilRisco: "",
        NecessarioRefazerSuitability: false,
      },
      produtos: null,
    };
  },
  async created() {
    await this.fetchConfiguracao(["Exibição termos dos produtos"]);
    this.configuracaoVisualizacaoTermosProdutos =
      this.getConfiguracoes("Exibição termos dos produtos")?.Valor == "N"
        ? false
        : true;

    if (!this.Edicao) {
      this.$store.dispatch("FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE");
    }

    this.$store.dispatch("FETCH_PERFIL_CLIENTE");
    this.$store.dispatch("FETCH_VERIFICAR_DISPENSA_QUESTIONARIO");
  },
  mounted() {
    this.$store.dispatch("FETCH_DISPENSA_QUESTIONARIO");
    this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
    this.$store.commit("SET_PERFIL_CLIENTE", null);
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;

    this.verificarConfigDispensaQuestionario();
    this.verificarSeRequisicoesFinalizaram("listaProdutos");
    this.verificarSeRequisicoesFinalizaram("listaProdutosCliente");
    this.verificarPerfilCliente();
    this.verificarInfoDispensaQuestionario();

    if (this.infoObjDispensa == null) {
      this.dispensaQuestionario = this.infoDispensaQuestionario;

      if (this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0) {
        this.dispensar = true;
        this.dispensarAnterior = true;
      } else {
        this.dispensar = false;
        this.dispensarAnterior = false;
      }
    }
  },
  watch: {
    perfilSuitabilityPreview() {
      if (this.Edicao && this.perfilSuitabilityPreview?.Id) {
        this.obterProdutos();
      }
    },
    configDispensaQuestionario() {
      this.verificarConfigDispensaQuestionario();
    },
    listaProdutos() {
      this.verificarSeRequisicoesFinalizaram("listaProdutos");
    },
    listaProdutosCliente() {
      this.verificarSeRequisicoesFinalizaram("listaProdutosCliente");
    },
    infoDispensaQuestionario() {
      this.dispensaQuestionario = this.infoDispensaQuestionario;

      if (this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0) {
        this.dispensar = true;
        this.dispensarAnterior = true;
      } else {
        this.dispensar = false;
        this.dispensarAnterior = false;
      }
    },
    perfilCliente() {
      this.verificarPerfilCliente();
    },
  },
  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    obterProdutos() {
      if (this.perfilSuitabilityPreview?.Id > 0) {
        this.$store.dispatch(
          "FETCH_CONSULTA_LISTA_PRODUTOS_PREVIEW",
          this.perfilSuitabilityPreview?.Id,
        );
      } else {
        this.$store.dispatch("FETCH_CONSULTA_LISTA_PRODUTOS");
      }
      this.$store.dispatch("FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE");
    },
    verificarInfoDispensaQuestionario() {
      this.dispensaQuestionario = this.infoDispensaQuestionario;

      if (this.dispensaQuestionario?.MotivoDispensaQuestionarioId > 0) {
        this.dispensar = true;
        this.dispensarAnterior = true;
      } else {
        this.dispensar = false;
        this.dispensarAnterior = false;
      }
    },
    verificarConfigDispensaQuestionario() {
      this.verificarSeRequisicoesFinalizaram("configDispensaQuestionario");
      if (this.configDispensaQuestionario != null) {
        var configuracaoDispensa = this.configDispensaQuestionario.filter(
          (config) => config.Chave == "Dispensa do questionário",
        );

        if (configuracaoDispensa[0] != null) {
          if (configuracaoDispensa[0].Valor == "Não") {
            this.bloquearDispensaQuestionario = true;
          }
        }
      }
    },
    verificarPerfilCliente() {
      this.verificarSeRequisicoesFinalizaram("perfilCliente");
      this.filtroPerfilNome = "";

      if (this.perfilCliente)
        if (this.perfilCliente[0]) {
          this.dadosUsuario = this.perfilCliente[0];
          this.filtroPerfilNome = this.perfilCliente[0].PerfilRisco;
          this.validarFormulario();
          this.obterProdutos();

          if (
            this.dadosUsuario != null &&
            this.dadosUsuario.NecessarioRefazerSuitability
          ) {
            this.$alert({
              icon: "warning",
              title: "Atualização Necessária",
              text: "Seu questionário de suitability precisa ser respondido novamente para continuidade do cadastro.",
            });
          }
        } else {
          this.filtroPerfilNome = "";
          this.dadosUsuario = {
            PerfilRisco: "",
            NecessarioRefazerSuitability: false,
          };
          this.$store.commit("SET_LISTA_PRODUTOS", []);
          this.$store.commit("SET_LISTA_PRODUTOS_CLIENTE", []);
        }
    },
    verificarSeRequisicoesFinalizaram(requisicao) {
      if (requisicao == "listaProdutos") {
        this.requisicoes.listaProdutos = true;
      } else if (requisicao == "perfilCliente") {
        this.requisicoes.perfilCliente = true;
      } else if (requisicao == "listaProdutosCliente") {
        this.requisicoes.listaProdutosCliente = true;
      } else if (requisicao == "configDispensaQuestionario") {
        this.requisicoes.configDispensaQuestionario = true;
      }

      if (
        (this.requisicoes.listaProdutos &&
          this.requisicoes.perfilCliente &&
          this.requisicoes.listaProdutosCliente &&
          this.requisicoes.configDispensaQuestionario) ||
        this.nomeEmpresa == "ACTUAL"
      ) {
        this.requisicoes.finalizado = true;
      }
    },
    abrirQuestionario() {
      this.$store.commit("SET_MODAL_QUESTIONARIO", true);
    },
    lerTermos(id) {
      this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", id);
    },
    visualizarTermos(id) {
      this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", id);
      this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", true);
    },
    validarFormulario() {
      var mensagemAlerta =
        "Para a conclusão do cadastro, é necessário o preenchimento do questionário ou a dispensa do questionário.";

      if (this.bloquearDispensaQuestionario) {
        mensagemAlerta =
          "Para a conclusão do cadastro, é necessário o preenchimento do questionário";
      }

      var permitirAvancarLocal = true;

      if (
        this.dadosUsuario.NecessarioRefazerSuitability &&
        !(this.perfilSuitabilityPreview?.Id > 0)
      ) {
        this.$alert({
          icon: "error",
          title: "Concluir cadastro",
          text: "Para a conclusão do cadastro, seu questionário de suitability precisa ser respondido novamente.",
        });
        permitirAvancarLocal = false;
      }

      if (
        this.dadosUsuario.PerfilRisco == "" &&
        !(this.perfilSuitabilityPreview?.Id > 0)
      ) {
        this.$alert({
          icon: "error",
          title: "Concluir cadastro",
          text: mensagemAlerta,
        });
        permitirAvancarLocal = false;
      }
      this.permitirAvancar = permitirAvancarLocal;
      return this.permitirAvancar;
    },
    abrirModalDispensa() {
      if (
        this.dispensarAnterior != this.dispensar &&
        this.dispensar == "false"
      ) {
        this.$alert({
            icon: "warning",
            title: "Remover dispensa de questionário",
            text: "Para realizar essa operação os produtos aderidos serão cancelados. Deseja seguir?",
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.alterarDispensa();
            } else {
              this.dispensar = this.dispensarAnterior;
            }
          });
      } else {
        this.alterarDispensa();
      }
    },
    alterarDispensa() {
      const valorAnterior = this.dispensarAnterior;
      this.dispensarAnterior = this.dispensar;

      if (
        this.dispensar == "false" ||
        (this.dispensar &&
          this.dispensaQuestionario.MotivoDispensaQuestionarioId > 0)
      ) {
        if (this.dispensar == "false") {
          this.dispensaQuestionario.MotivoDispensaQuestionarioId = "0";
          if (valorAnterior && valorAnterior !== "false") {
            this.$store.commit("SET_DISPENSA_QUESTIONARIO_REMOVIDA", true);
            this.$store.commit("REMOVE_ETAPA_CONCLUIDA", 9);
          }
        } else if (
          (this.dispensar == "true" || this.dispensar == true) &&
          this.dispensaQuestionario.MotivoDispensaQuestionarioId > 0
        ) {
          this.$store.commit("SET_ETAPA_CONCLUIDA", 9);
          this.$store.commit("SET_DISPENSA_QUESTIONARIO_REMOVIDA", false);
        }
        this.salvarAlteracoesLocalmente();
        this.salvarInformacoes();
      } else {
        this.salvarAlteracoesLocalmente();
      }
    },
    proximaEtapa() {
      if (this.validarFormulario()) {
        this.$store.commit("SET_FICHA_CONCLUIR", true);
        this.salvarInformacoes();
      }
    },
    salvarAlteracoesLocalmente() {
      this.$store.commit(
        "SET_PF_PJ_SALVAR_INFO_DISPENSA",
        this.dispensaQuestionario,
      );
    },
    salvarInformacoes() {
      this.$store.commit("SET_ETAPA_CONCLUIDA", 8);
      this.$store.commit("SET_PJ_SALVAR_INFO", true);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Minimal custom styles - most styling is now handled by Tailwind CSS */

.badge-novo-questionario {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #f5a623;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
</style>
